/* eslint-disable import/first */
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import { useNavigate } from '@reach/router';
import Typography from '@material-ui/core/Typography';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;
const { selectStoreEntities } = Slices.storeSlice;
import Header from '../../components/Header';
import { HiChevronRight } from '@react-icons/all-files/hi/HiChevronRight';

const { selectCurrentCountry } = Slices.profileSlice;
const { selectBaseURL, selectOrderModesByCountry, selectCountryValidations } = Slices.configSlice;
import StoreLocatorPlaceOrder from '../../components/StoreLocatorPlaceOrder';
import { StoreLocatorIcon, FutureClock } from '../../components/Icons';
import LanguageButton from '../../components/LanguageButton';
import StoreMap from '../StoreLocator/StoreMap';
import SeoTitle from '../../components/SeoTitle';
import storeImgEn from './beatinEn_cleanup.png';
import storeImgAr from './beatinAr1.png';
import css from './index.module.scss';

function StoreLocatorDetail({ storeSlug, storeId }) {
  const isDesktop = useSelector(selectDesktop);
  const storeList = useSelector(selectStoreEntities);
  const navigate = useNavigate();
  const [store, setStore] = useState(null);
  const [popup, setPopup] = useState(false);
  const [disablePlaceOrder, setDisablePlaceOrder] = useState(false);
  const storeState = useSelector((state) => state.store);
  const country = useSelector(selectCurrentCountry);
  const intl = useIntl();
  const imgSrc = intl.locale === 'en' ? storeImgEn : storeImgAr;
  // const homeBaseURL = useSelector(selectHomeBaseURL);
  // eslint:fix homeBaseURL is defined but never used
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));

  const orderModes = useSelector((state) => selectOrderModesByCountry(state, country));
  const imgBaseUrl = useSelector(selectBaseURL);
  // const handleChange = (event) => {
  //   console.log(event.target.value);
  // };
  // eslint:fix handleChange is defined a value but never used
  React.useEffect(() => {
    Object.values(storeList || {}).every((val) => {
      if (val.storeId === +storeId) {
        setStore(val);
        return false;
      }
      return true;
    });
  }, []);

  React.useEffect(() => {
    const usableOrderModes = orderModes.filter(
      (orderMode) => orderMode.type != 'DELIVERY' && orderMode.enable
    ).length;
    if (usableOrderModes < 1) setDisablePlaceOrder((prev) => true);
  }, [orderModes]);

  React.useEffect(() => {
    if (storeState.status === 'succeeded') {
      let getStore = false;
      Object.values(storeList || {}).every((val) => {
        if (val.storeId === +storeId) {
          getStore = true;
          return false;
        }
        return true;
      });
      if (!getStore) navigate(`/${intl.locale}/storelocator`, { replace: true });
    }
  }, [intl.locale, navigate, store, storeId, storeList, storeState.status]);
  if (store === null) {
    return '';
  }

  const { startTime = '', endTime = '' } = store;
  var d = new Date(startTime); /* midnight in China on April 13th */
  const startStore = d.toLocaleTimeString('en-US', {
    timeZone: 'UTC',
    hour: '2-digit',
    minute: '2-digit',
  });

  var end = new Date(endTime); /* midnight in China on April 13th */
  const endStore = end.toLocaleTimeString('en-US', {
    timeZone: 'UTC',
    hour: '2-digit',
    minute: '2-digit',
  });
  const storeName = 'name_' + intl.locale.toLowerCase();
  const storeAddress = 'address_' + intl.locale.toLowerCase();

  const types = {
    STORE: store.services.tak,
    DELIVERY: store.services.del,
    CARHOP: store.services.carHop,
    DINEIN: store.services.din,
    DRIVETHRU: store.services.driveThru,
  };
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const instr = countryValidations?.storeQRPopupData.instr;
  const handlePlaceOrderPop = () => setPopup(true);

  return (
    <Grid className={css.root}>
      <SeoTitle
        id="storelocation"
        storename={store[storeName]}
        storeDetails={store}
        opneingHours={intl.formatMessage(
          { id: 'carhop_openinghours' },
          { startTime: startStore, endTime: endStore }
        )}
        countryName={country}
      />
      <Header
        className={css.clearHeader}
        title={<FormattedMessage id="storeLocatorDetail_heading" defaultMessage="Store Details" />}
        actionButtons={[<LanguageButton />]}
      />
      <div className={css.wrapper}>
        {isDesktop && (
          <div className={css.pageHeading}>
            <FormattedMessage id="storeLocatorDetail_heading" defaultMessage="Store Details" />
          </div>
        )}
        <div className={css.storeWrapper}>
          <div className={css.innerWrapper}>
            <div className={css.mapContainer}>
              <div className={css.mapHeading}>
                <div className={css.icon}>
                  <StoreLocatorIcon />
                </div>
                <div className={css.desc}>
                  <Typography variant="h1" className={css.storeTitle}>
                    {store[storeName]}
                  </Typography>
                  <Typography variant="h2" className={css.storeSubtitle}>
                    {store[storeAddress]}
                  </Typography>
                  <Typography variant="h3" className={css.storeOpeningHours}>
                    <FormattedMessage
                      id={`carhop_openinghours`}
                      values={{
                        startTime: startStore,
                        endTime: endStore,
                      }}
                    />
                  </Typography>
                </div>
              </div>
              <div className={css.map}>
                <StoreMap
                  zoom={16}
                  defaultLoc={{ lat: store.location.latitude, lng: store.location.longitude }}
                  // storeDetail={store}
                  refineStoreList={[store.storeId]}
                />
              </div>
            </div>

            <div className={css.services}>
              <Typography variant="h3" className={css.storeSectionHeading}>
                {' '}
                <FormattedMessage
                  id="storeLocatorDetail_services"
                  defaultMessage="Services available here"
                />
              </Typography>
              {/* {isDesktop ? <Divider></Divider> : ''} */}
              <div className={css.types}>
                {orderModes.map((el) => {
                  const title = intl.locale.toLowerCase() === 'en' ? el.name : el.nameAr;
                  const imgSrc = `${imgBaseUrl.home}${el.imageAlt}`;
                  //  : orderMode.image
                  if (!types[el.type]) {
                    return '';
                  }
                  return (
                    <div className={css.itm}>
                      <div className={css.typeIcon}>
                        <img width="30" src={imgSrc} alt={title} />
                      </div>
                      <div className={css.typeTitle}>{title}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className={css.openingHours}>
              <div className={css.heading}>
                <div className={css.headingIcon}>
                  <FutureClock />
                </div>
                <Typography variant="h3" className={css.storeSectionHeading}>
                  <FormattedMessage
                    id="storeLocatorDetail_openingClosingHours"
                    defaultMessage="Opening and closing hours"
                  />
                </Typography>
              </div>
              <div className={css.hoursWrapper}>
                <Typography variant="body1" component="div" className={css.storeSectionHeading}>
                  <FormattedMessage
                    id="storeLocatorDetail_openingHours"
                    defaultMessage="Opening hours"
                  />
                  <span>
                    {startStore}-{endStore}
                  </span>
                </Typography>

                <div className={css.days}>
                  <div className={css.row}>
                    <div className={css.day}>
                      <FormattedMessage
                        id="storeLocatorDetail_openingHours_Days"
                        defaultMessage="Days"
                      />
                    </div>
                    <div className={css.hour}>
                      <FormattedMessage
                        id="storeLocatorDetail_openingHours_Delivery"
                        defaultMessage="Delivery"
                      />
                    </div>
                    <div className={css.hour}>
                      <FormattedMessage
                        id="storeLocatorDetail_openingHours_Carryout"
                        defaultMessage="Carryout"
                      />
                    </div>
                  </div>
                  {days.map((el) => {
                    return (
                      <div className={css.row}>
                        <div className={css.day}>
                          <FormattedMessage id={`storeDetail_${el}`} defaultMessage={el} />
                        </div>
                        <div className={css.hour}>
                          {startStore}-{endStore}
                        </div>
                        <div className={css.hour}>
                          {startStore}-{endStore}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className={css.outerWrapper}>
            <div className={css.innerOuter}>
              <div className={css.icon}>
                <img src={imgSrc} alt="Beat the store" />
              </div>
              {/* <div className={css.contentSection}>
                {instr?.map((value, i) => {
                  return (
                    <div className={css.instItem} key={i}>
                      <div className={css.instIcon}>
                        <img
                          src={`${imgBaseUrl.home}${value.image}`}
                          width="42"
                          alt="instruction icon"
                        />
                      </div>
                      <div className={css.text}>{value.text}</div>
                    </div>
                  );
                })}
              </div> */}
            </div>
            {isDesktop ? (
              <div
                className={css.placeOrder + ' ' + (disablePlaceOrder ? css.disablePlaceOrder : '')}
                onClick={handlePlaceOrderPop}
              >
                <div
                  className={
                    css.checkoutButton +
                    ' ' +
                    (disablePlaceOrder ? css.disablePlaceOrderButton : '')
                  }
                >
                  <span className={css.label}>
                    <FormattedMessage id="storeLocator_placeOrder" defaultMessage="Place order" />
                  </span>
                  {/* <span className={css.chevron}>
                    <HiChevronRight />
                  </span> */}
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
          {!isDesktop ? (
            <div
              className={css.placeOrder + ' ' + (disablePlaceOrder ? css.disablePlaceOrder : '')}
              onClick={handlePlaceOrderPop}
            >
              <div
                className={
                  css.checkoutButton + ' ' + (disablePlaceOrder ? css.disablePlaceOrderButton : '')
                }
              >
                <span className={css.label}>
                  <FormattedMessage id="storeLocator_placeOrder" defaultMessage="Place order" />
                </span>
                <span className={css.chevron}>
                  <HiChevronRight />
                </span>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      {popup && (
        <StoreLocatorPlaceOrder setOpen={setPopup} isOpen={popup} storeId={store.storeId} />
      )}
      <footer className={css.footer}></footer>
    </Grid>
  );
}

export default StoreLocatorDetail;
